import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { STORAGE_KEYS } from "../services/navigation";
import { getCycles } from "../services/cycleApi";
import useAsync from "../hooks/useAsync";

const api = { getCycles };

const CycleContext = createContext(null);

export function CycleProvider({ children }) {
  const { data, loading, error, reload } = useAsync(() => api.getCycles(), []);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(STORAGE_KEYS.selectedCycle));

  const cycles = useMemo(() => data || [], [data]);
  const activeCycle = cycles.find((c) => c.status === "Active") || null;
  const cycle = cycles.find((c) => c.id === selectedId) || activeCycle || cycles[0] || null;

  const setCycleId = useCallback((id) => {
    localStorage.setItem(STORAGE_KEYS.selectedCycle, id);
    setSelectedId(id);
  }, []);

  const isStageOpen = useCallback(
    (key) => Boolean(cycle && cycle.status === "Active" && cycle.stages.find((s) => s.key === key)?.status === "open"),
    [cycle]
  );

  const value = useMemo(
    () => ({ cycles, cycle, cycleId: cycle?.id || null, activeCycle, setCycleId, isStageOpen, loading, error, reload }),
    [cycles, cycle, activeCycle, setCycleId, isStageOpen, loading, error, reload]
  );

  return <CycleContext.Provider value={value}>{children}</CycleContext.Provider>;
}

export function useCycle() {
  const ctx = useContext(CycleContext);
  if (!ctx) throw new Error("useCycle must be used inside CycleProvider");
  return ctx;
}
